import Page from "webPage/Page";
import $ from "jquery";

Page.register("single-product", () => {
    $("body").on('change', ".js-country-value", function () {
        $(this).parents("form").submit();
    })
});